<template>
	<div class="grid mb-4">
		<div class="title">Создание организации</div>
		<form class="organization" @submit.prevent>
			<BaseGroup title="Основные данные">
				<BaseInput v-model="organization.name" placeholder="Название" />
				<BaseInput v-model="organization.inn" placeholder="ИНН" />
				<BaseInput v-model="organization.address" placeholder="Юридический адрес" />
				<BaseInput v-model="organization.email" placeholder="Электронная почта" type="email" />
			</BaseGroup>
			<BaseButton @click="saveOrganization"> Сохранить </BaseButton>
		</form>
	</div>
</template>

<script>
import BaseGroup from '@/components/ui/BaseGroup'
import BaseInput from '@/components/ui/BaseInput'
import BaseButton from '@/components/ui/BaseButton'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useApi } from '@/modules/api'
import { useAlert } from '@/modules/composition/useAlert'

export default {
	name: 'OrganizationNew',
	components: {
		BaseInput,
		BaseGroup,
		BaseButton
	},
	setup () {
		const router = useRouter()
		const organization = ref({})
		const { errorAlert, infoAlert } = useAlert()

		const saveOrganization = async () => {
			const { post, error } = useApi('/organization')

			const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/

			if (!organization.value.email.match(emailRegex)) {
				errorAlert('Не верно указана почта')
				return
			}
			await post({
				inn: organization.value.inn,
				name: organization.value.name,
				address: organization.value.address,
				email: organization.value.email
			})

			if (error.value != null) {
				errorAlert(error.value)
			} else {
				infoAlert('Организация успешно создана!')
				router.push({ name: 'Organizations' })
			}
		}

		return {
			organization,
			saveOrganization
		}
	}
}
</script>

<style lang="scss">
	.organization {
		.group {
			width: 50%;
			margin-bottom: 20px;
		}
		.button {
			&:not(:last-of-type) {
				margin-right: 10px;
			}
		}
	}
</style>
